import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { MtSocialProvidersAccountProvidersQuery } from '@gql/graphql';
import { MtSocialProviderType } from '@presentation/components';
import { useMemo } from 'react';

export const MT_SOCIAL_PROVIDERS_ACCOUNT_PROVIDERS = graphql(`
  query MtSocialProvidersAccountProviders {
    accountMe {
      id
      googleId
      firebaseId
      facebookId
    }
  }
`);

export const useAccountProviders = () => {
  const { data, error, loading } = useQuery<MtSocialProvidersAccountProvidersQuery>(
    MT_SOCIAL_PROVIDERS_ACCOUNT_PROVIDERS,
  );

  const providersTypes = useMemo((): MtSocialProviderType[] => {
    const types: MtSocialProviderType[] = [];
    const account = data?.accountMe ?? undefined;
    if (account?.firebaseId) {
      types.push(MtSocialProviderType.FIREBASE);
    }
    if (account?.googleId) {
      types.push(MtSocialProviderType.GOOGLE);
    }
    if (account?.facebookId) {
      types.push(MtSocialProviderType.FACEBOOK);
    }
    return types;
  }, [data?.accountMe]);

  return {
    providersTypes,
    providersLoading: loading,
    providersError: error,
  };
};
